var _clipPath, _clipPath2, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFeedback(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 26.194,
    viewBox: "0 0 25.69 26.194",
    width: 25.69,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m1281.894 852.586a1.333 1.333 0 0 1 -1.334-1.336v-5.94h-4.56a1.335 1.335 0 0 1 -1.334-1.336v-16.248a1.334 1.334 0 0 1 1.334-1.334h23.019a1.335 1.335 0 0 1 1.336 1.334v16.248a1.337 1.337 0 0 1 -1.336 1.336h-9.3l-6.885 6.884a1.336 1.336 0 0 1 -.94.392zm-4.558-9.946h4.558a1.334 1.334 0 0 1 1.334 1.334v4.054l5-5a1.334 1.334 0 0 1 .944-.39h8.515v-13.577h-20.349z",
    transform: "translate(-1274.666 -826.392)"
  }))), _clipPath2 || (_clipPath2 = /*#__PURE__*/React.createElement("clipPath", {
    id: "b"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m.114.14h26v26h-26z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m1281.894 852.586a1.333 1.333 0 0 1 -1.334-1.336v-5.94h-4.56a1.335 1.335 0 0 1 -1.334-1.336v-16.248a1.334 1.334 0 0 1 1.334-1.334h23.019a1.335 1.335 0 0 1 1.336 1.334v16.248a1.337 1.337 0 0 1 -1.336 1.336h-9.3l-6.885 6.884a1.336 1.336 0 0 1 -.94.392zm-4.558-9.946h4.558a1.334 1.334 0 0 1 1.334 1.334v4.054l5-5a1.334 1.334 0 0 1 .944-.39h8.515v-13.577h-20.349z",
    fill: "#fff",
    fillRule: "evenodd",
    transform: "translate(-1274.666 -826.392)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeedback);
export default __webpack_public_path__ + "static/media/feedback.c71c10c408f93ed1e732ecef7ba2a3bc.svg";
export { ForwardRef as ReactComponent };